/* eslint-disable */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiEncoderService } from './api-encoder.service';
import { LoggerService } from './logger.service';
import { UtilsService } from './utils.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
};

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiServiceOld {
  //TODO - replace this with url stored in prefs after auth + locale determined
  url: string = environment.serverUrl;

  constructor(
    private http: HttpClient,
    private utils: UtilsService,
    private logger: LoggerService,
    private encoder: ApiEncoderService
  ) {
    this.logger.log('Api constructor', MSRemoteLoggerCategory.API_OLD_SERVICE);
  }

  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (const k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(this.url + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any) {
    let params = new HttpParams({ encoder: this.encoder });
    const self = this;

    function addParam(k, v) {
      if (v === null) {
        params = params.append(k, '');
      } else if (typeof v === 'object' || Array.isArray(v)) {
        params = params.append(k, self.utils.toJson(v));
      } else {
        params = params.append(k, v);
      }
    }

    for (const k in body) {
      const v = body[k];
      if (Array.isArray(v)) {
        for (const e of v) {
          addParam(k, e);
        }
      } else {
        addParam(k, v);
      }
    }
    this.logger.log('api post ' + JSON.stringify(params), MSRemoteLoggerCategory.API_OLD_SERVICE);
    return this.http.post(this.url + endpoint, params, httpOptions);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.url + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + endpoint, body, reqOpts);
  }

  updateUrl(url) {
    this.url = url;
  }
}
